import { createFileRoute } from '@tanstack/react-router';
import NotFound from '../common/NotFound';

const component = () => {
  return <NotFound />;
};

export const Route = createFileRoute('/NotFoundRoute')({
  component: component,
});
